import { useEffect } from "react";
import "./Bridge.css";

// 복이오리 앱 딥링크 스킴 (예: "bokiorishare://bridge"). 비어 있으면 앱 실행 시도 없이 fallback만 수행.
const DEEP_LINK_BASE = "";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.goldttak.bokiory_app";
const IOS_FALLBACK_PATH = "/bokiori";

const OG_TITLE = "시간 투자 대비 초고소득 앱테크 - 복이오리";
const OG_DESCRIPTION =
  "앱테크 최대 보상, 현금과 1대1 비율, 특별응모권까지 다양한 혜택이 존재하는 복이오리, 지금 바로 시작하고 다양한 혜택 받아가세요";
const OG_IMAGE_PATH = "/bokiori-assets/bokiori_thumbnail.png";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function Bridge2() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = OG_TITLE;
    upsertMeta("property", "og:title", OG_TITLE);
    upsertMeta("property", "og:description", OG_DESCRIPTION);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "description", OG_DESCRIPTION);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", OG_TITLE);
    upsertMeta("name", "twitter:description", OG_DESCRIPTION);

    if (OG_IMAGE_PATH) {
      const imageUrl = `${window.location.origin}${OG_IMAGE_PATH}`;
      upsertMeta("property", "og:image", imageUrl);
      upsertMeta("name", "twitter:image", imageUrl);
    }

    return () => {
      document.title = prevTitle;
    };
  }, []);

  const openApp = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryString = urlParams.toString();

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);

    const goFallback = () => {
      if (isIOS) {
        window.location.href = IOS_FALLBACK_PATH;
      } else if (isAndroid) {
        window.location.href = PLAY_STORE_URL;
      } else {
        alert("모바일 기기에서 접속해주세요.");
      }
    };

    if (!DEEP_LINK_BASE) {
      goFallback();
      return;
    }

    const deepLink = queryString
      ? `${DEEP_LINK_BASE}?${queryString}`
      : DEEP_LINK_BASE;

    if (isIOS || isAndroid) {
      window.location.href = deepLink;

      let appOpened = false;

      const handleVisibilityChange = () => {
        if (document.hidden) {
          appOpened = true;
        }
      };

      const handleBlur = () => {
        appOpened = true;
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);
      window.addEventListener("blur", handleBlur);

      setTimeout(() => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
        window.removeEventListener("blur", handleBlur);

        if (!appOpened && document.hasFocus()) {
          goFallback();
        }
      }, 3000);
    } else {
      alert("모바일 기기에서 접속해주세요.");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      openApp();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bridge-container">
      <div className="bridge-content">
        <h1 className="bridge-title">앱을 여는 중...</h1>
        <p className="bridge-message">잠시만 기다려주세요.</p>
        <button className="bridge-button" onClick={openApp}>
          앱 바로가기
        </button>
      </div>
    </div>
  );
}

export default Bridge2;
